import React from 'react'
import {Table, TableBody, TableRow, TableCell} from '@material-ui/core'
import FieldRow from './FieldRow'
import {useParams} from 'react-router'
import {ReservationConfigurationContext} from '../../context/ReservationConfiguration'
import LoadingIndicator from '../ReservationConfiguration/LoadingIcon'

const FieldList = ({search, selected, onChange = (e, data) => {}}) => {
  const {group_id} = useParams()
  const {filters, getGroupFilters} = React.useContext(ReservationConfigurationContext)

  // React.useEffect(() => {
  //   if (group_id && filters.data.length === 0) {
  //     getGroupFilters({group_id})
  //   }
  // }, [group_id, getGroupFilters, filters.data.length])

  // const filteredFilters = React.useMemo(() => {
  //   return filters.data.filter(f => f.field_name.toLowerCase().indexOf(search.toLowerCase()) !== -1)
  // }, [search, filters])
  React.useEffect(() => {
    if (group_id) {
      getGroupFilters({group_id, query: search})
    }
  }, [search, group_id, getGroupFilters])

  return (
    <div className="reservation-limit-reservable__field-list ap-scrollbar">
      {filters.isLoading && <LoadingIndicator style={{width: '100%'}} />}
      <Table className="ap-table">
        <TableBody>
          {!filters.isLoading && filters.data.length === 0 && (
            <TableRow>
              <TableCell align="center" className="ap-typography ap-typography--sm">
                No results found
              </TableCell>
            </TableRow>
          )}
          {filters.data.map(f => (
            <FieldRow
              data={f}
              selectedOptions={selected.find(s => s.field_id === f.field_id)?.value}
              onChange={onChange}
            />
          ))}
        </TableBody>
      </Table>
    </div>
  )
}

export default FieldList
